import React, { useState } from 'react';
import { Outlet, Navigate } from "react-router-dom";
import { getSubdirectory } from './utils/GetSubdirectory';
import useApp from './hooks/useApp';



const ProtectedRoutes = () => {
  
    const subdirectory = getSubdirectory();
    const token = localStorage.getItem(`${subdirectory}-token`);
    useApp()

    return (
        token ? <Outlet /> : <Navigate to="/login" replace />
    )
}

export default ProtectedRoutes
